import { HttpPushToWarehouse, HttpPushAttach } from '@/service/boss/distribution'
export default {
    computed: {
        imgUrl () {
            return {
                isCelebrity:'/picture/hongren.png',
                isSample:'/picture/yangpin.png',
                isReshipment:'/picture/bufa.png',
                isDismantlementfu:'/picture/chaifu.png',
                isDismantlementzi:'/picture/chaizi.png',
                isAddition:'/picture/lipin.png',
            }
        },
        distributionStatus () {
            return [
            {
                value: 0,
                label: this.$t("erp.distribution.created", {defaultValue: "已创建"}),
                color: 'b2cspan-success span-padding'
            }, {
                value: 1,
                label: this.$t("erp.distribution.pushed", {defaultValue: "已推送"}),
                color: 'b2cspan-info span-padding'
            }, {
                value: 2,
                label: this.$t("erp.b2c.orderstatus_shipped", {defaultValue: "已发货"}),
                color: 'b2cspan-light-content span-padding'
            }, {
                value: 3,
                label: this.$t("global.common.canceled", {defaultValue: "已取消"}),
                color: 'b2cspan-warning span-padding'
            }, {
                value: 5,
                label: this.$t("fbb.headlogistics.draft", { defaultValue: "草稿"}),
                color: 'b2cspan-dark-primary span-padding'
            }]
        },
        distributionException () {
            return [{
                value: '8888',
                label: this.$t('erp.distribution.buyLabel_system_error', { defaultValue: "购买面单-系统异常" })
            }, {
                value: '1111',
                label: this.$t("erp.distribution.pusherror", {defaultValue: "推送异常"})
            }, {
                value: '2222',
                label: this.$t("erp.distribution.pushfileerror", {defaultValue: "附件推送异常"})
            }, {
                value: '3333',
                label: this.$t("erp.distribution.pushlabelerror", {defaultValue: "推送label系统异常"})
            }, {
                value: '4444',
                label: this.$t("erp.b2c.errorcode_buylabelException", {
                    defaultValue: "购买面单异常",
                })
            }, {
                value: '5555',
                label: this.$t("fbb.inbound.error_receive", {
                    defaultValue: "回传异常",
                })
            }, {
                value: '6666',
                label: this.$t("erp.disturibution.upload_attach_error", {
                    defaultValue: "附件上传异常",
                })
            }, {
                value: '500',
                label: this.$t("erp.b2c.errorcode_systemException", {
                    defaultValue: "系统异常",
                })
            }, {
                value: '7777',
                label: this.$t("erp.disturibution.error_code_deliver_method", {
                    defaultValue: "发运方式异常",
                })
            }, {
                value: '800',
                label: this.$t("erp.distribution.errcode_deliver_error", {
                    defaultValue: "配货异常",
                })
            }]
        },
        packStatus () {
            return [{
                value: 0,
                label: 'UNKNOWN',
                color: 'color-warning'
            }, {
                value: 1,
                label: 'PRE_TRANSIT',
                color: 'color-primary'
            }, {
                value: 2,
                label: 'IN_TRANSIT',
                color: 'color-success'
            }, {
                value: 3,
                label: 'OUT_FOR_DELIVERY',
                color: 'color-warning'
            }, {
                value: 4,
                label: 'DELIVERED',
                color: 'color-error'
            }, {
                value: 5,
                label: 'AVAILABLE_FOR_PICKUP',
                color: 'color-error'
            }, {
                value: 6,
                label: 'RETURN_TO_SENDER',
                color: ''
            }, {
                value: 7,
                label: 'FAILURE',
                color: ''
            }, {
                value: 8,
                label: 'CANCELLED',
                color: ''
            },{
                value: 9,
                label: 'ERROR',
                color: ''
            },{
                value: 11,
                label: "Label Created",
                color: "",
            },]
        },
    },
    methods: {
        async pushWarehouse (idsArr, callback = () => {}) {
            await HttpPushToWarehouse({
                deliverOrderIds: idsArr
            }).then(res => {
                this.$VMessage.success(res.message)
                callback();
                // this.$emit('on-update')
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                callback();
            })
        },
        async pushAgain (idsArr, callback = () => {}) {
            await HttpPushAttach({
                deliverOrderIds: idsArr
            }).then(res => {
                this.$VMessage.success(res.message)
                callback();
                // this.$emit('on-update')
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                callback();
            })
        }
    }
}
